import PropTypes from "prop-types"

import { to_currency } from "helpers/number"

const AddonPrice = ({ price, retail_price }) => {
  return (
    <div className="tablet:mb-16 mb-8 flex items-end justify-center gap-4">
      <p className="text-sale text-30 tablet:text-32 tracking-tigher leading-30 flex items-center font-medium">
        <span className="text-20 tracking-tigher">
          {sl.config.default_currency}
        </span>
        <span>{price}</span>
      </p>
      <p className="text-grey-62 text-12 leading-20 font-medium">
        <strike>{to_currency(retail_price)}</strike>
      </p>
      {/* <div
        className="bg-grey-20 tablet:mx-8 h-(--base-height) tablet:h-(--tablet-height) mx-4"
        style={{
          "--base-height": "24px",
          "--tablet-height": "35px",
          width: "1px",
        }}
      />
      <div className="flex flex-col items-start justify-center">
        <p className="text-12 tracking-tigher leading-14 font-medium">
          Retail: <strike>{to_currency(retail_price)}</strike>
        </p>
        <p className="text-12 tracking-tigher leading-14 text-sale font-medium">
          Save: {to_currency(retail_price - price)}
        </p>
      </div> */}
    </div>
  )
}

AddonPrice.propTypes = {
  price: PropTypes.number,
  retail_price: PropTypes.number,
}

export default AddonPrice
